import * as React from 'react';
import { Col, Row, Button } from 'reactstrap';
import { IChild } from '../../../../share/types/case/children';
import { IAbductor, CompanionTypes } from '../../../../share/types/case/abductor';
import { IImageStatusType } from '../types/types';
import { momentAgeNow, momentBirthDateAge } from '../../../../share/utils/utils';
import { PersonLayout } from '../layouts/Person';

export interface IPersonInfoFormProps {
  type: string;
  personsInfo: Array<IChild | IAbductor>;
  addPerson: (type: string) => void;
  form: (name: string, required?: boolean) => void;
  removePerson: (personId: string, type: string) => void;
  setValue: (path: string, value: any) => void;
  disabled: boolean;
  ius: IImageStatusType | undefined;
  isEdit: boolean;
};

export interface IPersonInfoFormState {
  currentArray: string;
  isChild: boolean;
};

export class PersonInfoForm extends React.Component<IPersonInfoFormProps, IPersonInfoFormState> {
  constructor(props: IPersonInfoFormProps) {
    super(props);

    this.state = {
      currentArray: this.props.type === 'child' ? 'children' : 'abductors',
      isChild: this.props.type === 'child'
    };
  }

  public render() {
    const personsInfoTyped: Array<IChild | IAbductor> = this.props.personsInfo;
    return (
      <div className={"margin-forms"}>
        {personsInfoTyped.map((person: IChild | IAbductor, i: number) => <PersonLayout className="person-layout" key={`${this.props.type}-${i}`} that={this} person={person} index={i} />)}
        {this.addBtn()}
      </div>
    );
  }
  public addBtn() {
    return (
      <Row>
        <Col md={{ size: 12 }} className="margin-top">
          <Button disabled={this.props.disabled} id="addPerson" className="float-right btn-blue" onClick={() => this.props.addPerson(this.props.type)}>
            {`Add ${this.state.isChild ? 'child' : 'companion'}`}
          </Button>
        </Col>
      </Row>
    )
  }
  public form(id: number, key: string, required = true) {
    return this.props.form(`${this.state.currentArray}[${id}].${key}`, required)
  }

  public isEmpty = (id: number, key: string) => this.props.personsInfo[id][key] || this.props.personsInfo[id][key] !== '';

  public unitValueValidationFields(index: number, unitType: string) {
    return {
      onChange: (event) => {
        this.changeValue(index, unitType, event);
        if (!event.currentTarget.value || event.currentTarget.value === undefined) {
          this.props.setValue(`caseInfo.${this.state.currentArray}[${index}].${unitType}Unit`, '')
        }
      }
    }
  }

  public unitValidationFields(id: number, unitType: string) {
    return {
      name: `${this.state.currentArray}[${id}].${unitType}Unit`,
      disabled: this.props.disabled || this.props.personsInfo[id][unitType] === '' || this.props.personsInfo[id][unitType] === undefined,
      required: this.props.personsInfo[id][unitType],
      onChange: (event) => this.props.setValue(`caseInfo.${this.state.currentArray}[${id}].${unitType}Unit`, event.currentTarget.value)
    }
  }

  public getAgeByBirthDate(id: number) {
    return {
      onChange: (event) => {
        this.props.setValue(`caseInfo.${this.state.currentArray}[${id}].birthDate`, event.currentTarget.value)
        if (event.currentTarget.value) {
          this.props.setValue(`caseInfo.${this.state.currentArray}[${id}].age`, +momentAgeNow(event.currentTarget.value))
        }
      }
    }
  }

  public getBirthDatebyAge(id: number) {
    return {
      onChange: (event) => {
        this.props.setValue(`caseInfo.${this.state.currentArray}[${id}].age`, event.currentTarget.value)
        if (event.currentTarget.value) {
          this.props.setValue(`caseInfo.${this.state.currentArray}[${id}].birthDate`, momentBirthDateAge(event.currentTarget.value))
        }
      }
    }
  }

  public changeValue(id: number, key: string, event: any) {
    this.props.setValue(`caseInfo.${this.state.currentArray}[${id}].${key}`, event.currentTarget.value);
  }

  public imageHandler(personId: number, imageId: number) {
    const { ius, personsInfo } = this.props;
    const id = `${this.state.currentArray},${personId},${imageId}`;
    const status = ius && ius[id] && ius[id].status;
    const person = personsInfo[personId];
    const imageLabels = ['Portrait', 'Alternate', 'Progressed'];
    return {
      onChange: (base64: string) => this.props.setValue(`caseInfo.${this.state.currentArray}[${personId}].images[${imageId}]`, base64),
      loading: this.props.disabled,
      status,
      thumbnail: person.images && person.images[imageId] || '',
      labelText: imageLabels[imageId]
    }
  }

  public getCompanionTypeOptions() {
    return Object.keys(CompanionTypes).map(key => {
      const option = CompanionTypes[key]
      return <option key={option} value={option}>{option}</option>
    })
  }
}

export default IPersonInfoFormProps;
